// Тёмный «остров» канваса уровня — токены в контрактном шейпе LevelConfig.theme
// (плеер бренд не хардкодит, получает через host). Общий для PlayScreen и
// WildcardScreen (дизайн 2026-07-08), поэтому вынесен из PlayScreen.
export const CANVAS_THEME = {
  bg: '#F4ECDD', ink: '#2A241C',
  accent: '#2E8C74', accent2: '#B26A33',
  surface: '#1E1A14', overlay: 'rgba(30,26,20,0.85)',
  fontMono: "'Russo One', monospace", fontSans: "'Balsamiq Sans', sans-serif",
} as const;
